import React, { createContext, useContext, useEffect, useState } from 'react';
import { useFeature } from '@24i/nxg-sdk-smartott-shared/src/context/AppSettingsData';
import type { Stripe } from '@stripe/stripe-js';

interface ContextType {
    stripePromise: Promise<Stripe> | null;
}

const contextDefaults: ContextType = {
    stripePromise: null,
};

export const StripeContext = createContext<ContextType>(contextDefaults);

export const StripeProvider: React.FC = ({ children }) => {
    const [stripePromise, setStripePromise] = useState<Promise<Stripe> | null>(null);
    const inAppPurchases = useFeature('inAppPurchases')?.enabled || false;
    const stripeSettings = useFeature('stripe');
    const stripeEnabled = stripeSettings?.enabled || false;
    const publishableKey = stripeSettings?.publishableKey;

    useEffect(() => {
        if (inAppPurchases && stripeEnabled && publishableKey) {
            import('@stripe/stripe-js').then(({ loadStripe }) => {
                setStripePromise(loadStripe(publishableKey) as Promise<Stripe>);
            });
        }
    }, [stripeEnabled, publishableKey, inAppPurchases]);

    return (
        <StripeContext.Provider
            value={{
                stripePromise,
            }}
        >
            {children}
        </StripeContext.Provider>
    );
};

export const useStripe = () => useContext(StripeContext);
